import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["innerHTML"];
import { clsx } from 'clsx';
import { I18nInfo } from '@/user/models';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeEduIntro',
    setup(__props) {
        const t = new I18nInfo('eduCenter.home.sectionIntro');
        const cards = [
            {
                img: '/images/renewal/educenter_illu_1.svg',
                subtitle: t.translate('eduBasic.title'),
                description: t.translate('eduBasic.desc'),
            },
            {
                img: '/images/renewal/educenter_illu_2.svg',
                subtitle: t.translate('eduIntermediate.title'),
                description: t.translate('eduIntermediate.desc'),
            },
            {
                img: '/images/renewal/educenter_illu_3.svg',
                subtitle: t.translate('eduAdvanced.title'),
                description: t.translate('eduAdvanced.desc'),
            },
        ];
        const styles = {
            container: clsx('flex flex-col gap-32 mt-24', 'desktop:flex-row desktop:gap-16 desktop:mt-32'),
            item: clsx('text-center', 'desktop:flex-1'),
            imageCover: clsx('w-full h-160 p-30 bg-blue-150 rounded-12 flex w-full items-center justify-center mb-20', 'desktop:h-200'),
            image: clsx('w-80', 'desktop:w-96'),
            subtitle: clsx('text-title-2', 'desktop:text-title-1'),
            description: clsx('text-body-5 text-gray-800 mt-8', 'desktop:text-body-4'),
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", {
                class: _normalizeClass(styles.container)
            }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card, idx) => {
                    return _createElementVNode("li", {
                        key: idx,
                        class: _normalizeClass(styles.item)
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(styles.imageCover)
                        }, [
                            _createElementVNode("img", {
                                class: _normalizeClass(styles.image),
                                src: card.img,
                                alt: ""
                            }, null, 10, _hoisted_1)
                        ], 2),
                        _createElementVNode("strong", {
                            class: _normalizeClass(styles.subtitle)
                        }, _toDisplayString(card.subtitle), 3),
                        _createElementVNode("p", {
                            class: _normalizeClass(styles.description),
                            innerHTML: card.description
                        }, null, 10, _hoisted_2)
                    ], 2);
                }), 64))
            ], 2));
        };
    }
});
